// Centralized API configuration
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost/api';
const WS_BASE = process.env.REACT_APP_WS_URL || 'http://localhost';

export const apiConfig = {
  baseURL: API_BASE,
  wsURL: WS_BASE,
  endpoints: {
    ai: {
      decomposeWithContext: `${API_BASE}/ai/decompose-with-context`,
      generateContextQuestions: `${API_BASE}/ai/generate-context-questions`,
      recommendExpert: `${API_BASE}/ai/recommend-expert`,
      analyzeDependencies: `${API_BASE}/ai/analyze-dependencies`
    }
  }
} as const;

// Helper for building API URLs
export const buildApiUrl = (path: string): string => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${cleanPath}`;
};

export default apiConfig;